import { Command } from "mobx-firelink";
import { GetEventIndexes } from "Store/firebase/events";
//@UserEdit
export class SetBookEventIndex extends Command {
    Validate() {
        const { characterID, eventID, index, removeBeforeInsert } = this.payload;
        const oldIndexes = GetEventIndexes(characterID);
        const eventIDsOrdered = oldIndexes.VValues();
        const oldIndex = eventIDsOrdered.indexOf(eventID);
        if (index != null) {
            eventIDsOrdered.Move(eventID, index, removeBeforeInsert ?? false); // dnd system applies index-fixing itself, so don't apply here (by default)
        }
        else {
            eventIDsOrdered.Remove(eventID);
        }
        // data-fixer code; uncomment this section if the event-indexes collections get messed up (entries pointing to non-existent events)
        /*for (let {value: eventID} of eventIDsOrdered.Pairs()) {
            let event = await GetAsync(()=>GetEvent(eventID));
            if (event == null) {
                eventIDsOrdered.Remove(eventID);
            }
        }*/
        this.newIndexes = eventIDsOrdered; //.ToMap();
    }
    GetDBUpdates() {
        const { characterID } = this.payload;
        const updates = {};
        updates[`characters/${characterID}/.eventIndexes`] = this.newIndexes;
        return updates;
    }
}
